import { Button, Grid } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import AnimateButton from "ui-component/extended/AnimateButton";

const UpgradePlanCard = () => {
  return (
    <Grid item xs={12} mt={2}>
      <AnimateButton>
        <Button
          size="small"
          component={Link}
          to="/dashboard/subscription"
          fullWidth
          variant="outlined"
        >
          <FormattedMessage id="profile.actions.subscribe" />
        </Button>
      </AnimateButton>
    </Grid>
  );
};

export default UpgradePlanCard;
